import React from 'react';

export const SobaLayouts = { layout1: React.lazy(() => import('./Layout1/Layout1')) };
